/* global ajaxPath */
import listingFilters from './listing-filter.js';
import $ from 'jquery';

const loadMorePosts = {
  totalItems: 0,
  currentPage: 1,
  sending: false,
  blockContainer: false,

  // Initialize the function.
  init: (blockContainer) => {
    // return false if our block doesnt exist
    if (!$(blockContainer).length) return false;

    // listing element passed from app.js
    loadMorePosts.blockContainer = document.querySelector(blockContainer);

    // Get total number of items from Dataset.
    const listingWrapper = loadMorePosts.blockContainer.querySelector('.listing-wrapper');

    if (listingWrapper) {
      loadMorePosts.totalItems = listingWrapper.dataset.totalitems;

      // handleClick event with click event listener
      loadMorePosts.handleClick();
    }
  },

  // Click handler
  handleClick: () => {
    const listingWrapper = loadMorePosts.blockContainer.querySelector('.listing-wrapper');
    const loadMoreButton = loadMorePosts.blockContainer.querySelector('.load-more-btn');

    // click event
    if (loadMoreButton) {
      loadMoreButton.addEventListener('click', () => {
        loadMoreButton.disabled = true;

        loadMorePosts.currentPage = parseInt(listingWrapper.dataset.currentpage);

        // if (!loadMore.sending && loadMore.currentPage * 3 < loadMore.totalItems) {
        loadMorePosts.getMorePostsAjax(listingWrapper);
        // }
      });
    }
  },

  getMorePostsAjax: () => {
    const listingWrapper = listingFilters.blockContainer.querySelector('.listing-wrapper');
    const category = listingFilters.blockContainer.querySelector('li.active').dataset.title;

    // Get post type from dataset
    const postType = listingWrapper.dataset.posttype;
    let currentPage = parseInt(listingWrapper.dataset.currentpage);
    const currentPostList = listingWrapper.getAttribute('data-exclude');
    const offset = 6;

    // Set data for AJAX call
    const callData = {
      action: 'load_more_posts',
      post_type: postType,
      offset: offset * currentPage,
      exclude_posts: currentPostList,
      numberposts: offset,
      category,
    };

    $.ajax({
      url: ajaxPath.admin_path,
      data: callData,
      type: 'POST',
      beforeSend() {
        currentPage = Number(currentPage) + 1;
        if (!listingFilters.sending) {
          // Insert loading spinner as visual indication to user.
          // listingContainer.insertAdjacentHTML(
          //   'beforeend',
          //   `<div class="spinner">
          //         <div class="rect1"></div>
          //         <div class="rect2"></div>
          //         <div class="rect3"></div>
          //         <div class="rect4"></div>
          //         <div class="rect5"></div>
          //     </div>`
          // );
          // Set sending state to true.
          listingFilters.sending = true;
        }
      },
      success(response) {
        // Enable Button after success
        const loadMoreButtonTmp = loadMorePosts.blockContainer.querySelector('.load-more-btn');
        loadMoreButtonTmp.disabled = false;

        // Insert query response at bottom of container element.
        listingWrapper.insertAdjacentHTML('beforeend', response);

        // update our element list
        listingFilters.updateElementList(listingWrapper);

        // Increase page count to represent current page of items.
        listingWrapper.dataset.currentpage = currentPage;

        // check if we need our load more button
        const allChildren = listingWrapper.querySelectorAll('.item').length;
        const loadMoreButton = loadMorePosts.blockContainer.querySelector('.load-more-btn');

        // hide our load more if we need to
        if (parseInt(listingWrapper.dataset.totalitems) === allChildren) {
          loadMoreButton.classList.add('hide');
        }
      },
    });
  },
};

export default loadMorePosts;
